import { FC } from 'react';
import { Box, Text } from '@qga/roo-ui/components';
import { CreditVoucherDisclaimer } from 'components/Disclaimers';
import { useCancellationQuote } from 'pages/CancellationQuotePage/CancellationQuoteProvider';
import * as track from 'lib/gaTracking/cancelBookingPageEvents';
import { RefundType } from 'lib/graphql';
import getRefundLabel from './utils/getRefundLabel';
import RefundOptionField from './components/RefundOptionField';

const RefundOptionsForm: FC = () => {
  const { setRefundType, refundType, cancellation } = useCancellationQuote();

  const handleChange = (value: RefundType) => {
    setRefundType(value);
    track.refundOptionsToggle(value);
  };

  return (
    <Box is="form">
      <RefundOptionField value="NORMAL" activeValue={refundType} onChange={handleChange}>
        {getRefundLabel(cancellation)}
      </RefundOptionField>

      <RefundOptionField value="CREDIT_NOTE" activeValue={refundType} onChange={handleChange}>
        <Text>Credit Voucher</Text>
        <CreditVoucherDisclaimer.Link />
      </RefundOptionField>
    </Box>
  );
};

export default RefundOptionsForm;
